import React,{useState} from 'react';
import{Modal,Box,Button,Typography,Backdrop,CircularProgress} from '@mui/material';
import { handleMucjCableDelete } from './DeleteCablePopup.util';
const DeleteCablePopup = ({setMucjLoader,mucjLoader,selectedMUCJRows,params,url2,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg}) =>{
    
    const [open, setOpen] = useState(false);
    
    //Handle form submission
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setOpen(false);//close modal
        
//        if (selectedMUCJRows.length > 0) {
            try {
                for (const row of selectedMUCJRows) {
                    const passedData = {  
                        cable: row.cable_id,  
                        cr_ref: row.cr_ref, 
                        job_id: row.job_id, 
                    };
                    await handleMucjCableDelete(setMucjLoader,passedData,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg,params,setOpen,url2,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows);
                }
            } catch (error) {
                console.error(error);
              }
//        }
    }

    return(
        <div>
            <Button id='mucj-delete-button' style={{ color:  "white", backgroundColor: selectedMUCJRows.length > 0 ? "#142032" : "rgb(153, 153, 174)", marginRight: "10px", marginBottom: "10px",fontSize:"12",height:"30px" }} disabled={selectedMUCJRows.length === 0} onClick={()=>setOpen(true)}>Delete</Button>
            <Modal open={open} >
                <Box
                sx={{
                    position:"absolute",
                    top:"50%",
                    left:"50%",
                    transform:"translate(-50%,-50%)",
                    width:400,
                    bgcolor:"background.paper",
                    boxShadow:24,
                    p:4,
                    borderRadius:2,
                }}
                >
                    <Typography variant="h6" id='mucj-delete-popup-description'>Do you want to delete the row?</Typography>
                    <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:"1rem"}} id='mucj-delete-popup'>
                        <Box  sx={{ display: 'flex',justifyContent:'flex-end',mr:3.5, mt: 2 }}>
                            <Button variant="contained" id='mucj-delete-dismiss-button' onClick={()=>setOpen(false)} style={{ color: "white", backgroundColor: "#142032", marginRight: "10px", fontSize: "12", height: "26px" }}>DISMISS</Button>
                            <Button type="submit" variant="contained" id="mucj-delete-apply-buton" style={{ color: "white", backgroundColor: "#142032", fontSize: "12", height: "26px" }} sx={{ mr: 1 }} >APPLY</Button>
                        </Box>

                    </form>
                </Box>
            </Modal>
              <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={mucjLoader}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
            
        </div>

        
    )
}

export default DeleteCablePopup;